module.exports = __webpack_public_path__ + "static/img/banner.f96619d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom_mobile/banner.png
// module id = 2xJt
// module chunks = 1